import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { SnackBarService } from 'src/app/shared-modules/stateless/snack-bar/services';

import { SystemLanguagesService } from '../../services';
import * as fromActions from '../actions';

@Injectable()
export class SystemLanguagesEffects {
  constructor(
    private actions$: Actions,
    private systemLanguagesService: SystemLanguagesService,
    private snackBar: SnackBarService
  ) {}

  loadSystemLanguages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadSystemLanguages),
      switchMap(() =>
        this.systemLanguagesService.loadSystemLanguages().pipe(
          map((data) =>
            fromActions.loadSystemLanguagesSuccess({ payload: data })
          ),
          catchError((error) =>
            of(fromActions.loadSystemLanguagesFailure({ payload: error }))
          )
        )
      )
    )
  );

  loadSystemLanguagesFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(fromActions.loadSystemLanguagesFailure),
        tap(({ payload }) => {
          this.snackBar.open(
            `Failed to load system languages, ${payload?.message}`,
            'FAILURE',
            3000
          );
        })
      );
    },
    { dispatch: false }
  );
}
